import React, { useEffect, useState } from "react";
import { Typography, Tag, Alert, Space, Tooltip, Spin } from "antd";
import { TagOutlined } from "@ant-design/icons";
import { motion } from "framer-motion";
import styles from "./SuggestedKeywords.module.scss";
import { KeywordCloud } from "..";
import { TIME_FILTER_TYPE } from "Explore/Config/constraint";
import useDeviceCheck from "Hooks/useDeviceCheck";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import { Button } from "@mui/material";
import { IconPack } from "Explore/Config/Icons";
import ZoomInMapIcon from "@mui/icons-material/ZoomInMap";

const { Text } = Typography;

const SuggestedKeywords = ({ keywords, onKeywordClick, noResultsMessage }) => {
  const { isMobile } = useDeviceCheck();
  const [showMore, setShowMore] = useState(false);
  const [granularityLevel, setGranularityLevel] = useState(1);
  const [selectedKeywords, setSelectedKeywords] = useState([]);
  const [selectedKeywordsQueue, setSelectedKeywordsQueue] = useState([]);

  useEffect(() => {
    onKeywordClick(selectedKeywords.map((k) => k.value));
  }, [selectedKeywords]);

  return (
    <section className={styles.suggestedKeywordsContainer}>
      {noResultsMessage && (
        <Alert
          message={noResultsMessage}
          type="warning"
          showIcon
          className={styles.noResultsMessage}
        />
      )}
      <div className={styles["title__container"]}>
        <h3 className={styles["title"]}>
          <AutoAwesomeIcon
            fontSize="20px"
            htmlColor="var(--accent-color-medium)"
          />
          Jump to a Research Area
        </h3>
        <Button
          className={styles["show-more-button"]}
          endIcon={showMore ? <ZoomInMapIcon /> : IconPack.panZoom}
          onClick={() => setShowMore(!showMore)}
          size={isMobile ? "small" : "medium"}
        >
          {showMore ? "Show less" : "Show more"}
        </Button>
      </div>

      {showMore ? (
        <KeywordCloud
          hideTitle
          concept={keywords}
          selectedKeywords={selectedKeywords}
          setSelectedKeywords={setSelectedKeywords}
          granularityLevel={granularityLevel}
          setGranularityLevel={setGranularityLevel}
          timeFilterType={TIME_FILTER_TYPE.NONE}
          selectedKeywordsQueue={selectedKeywordsQueue}
          setSelectedKeywordsQueue={setSelectedKeywordsQueue}
          chart_height={isMobile ? 330 : 300}
          hideOperation={true}
          scaleFactor={1.1}
          padding={2}
          maxFontSize={isMobile ? 20 : 24}
        />
      ) : (
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3 }}
          className={styles["suggested-keyword--list"]}
        >
          {keywords.isLoading ? (
            <div style={{ width: "100%", textAlign: "center" }}>
              <Spin />
            </div>
          ) : (
            (keywords?.data || []).map((keyword) => (
              <Button
                key={keyword.value}
                className={styles["suggested-keyword--item"]}
                onClick={() => setSelectedKeywords([keyword])}
                variant="contained"
              >
                {keyword.value}
              </Button>
            ))
          )}
        </motion.div>
      )}
    </section>
  );
};

export default SuggestedKeywords;
